import { useClientPortalAPI } from "@certn/api";
import { Picker, AvatarTrigger } from "@certn/cascadia-react";
import { useTranslation } from "react-i18next";

import { useQueryParams } from "../../hooks/useQueryParams";
import { useUser } from "../../hooks/useUser";
import { sortPickerItems } from "../../utils/sortPickerItems";

export function FilterRequestorType() {
  const filterParams = useQueryParams();
  const { details: userDetails } = useUser();
  const { t } = useTranslation();

  function useTaskTypes() {
    const { data, isLoading } = useClientPortalAPI(
      "/api/internal/client-portal/tasks/types/"
    );
    return { taskTypes: data, isLoading };
  }

  function useRequestingUsers() {
    const { data, isLoading } = useClientPortalAPI(
      "/api/internal/client-portal/users/requestors/"
    );
    return { requestors: data, isLoading };
  }
  const taskTypes = useTaskTypes();
  const requestors = useRequestingUsers();

  return (
    <>
      <Picker
        isLoading={requestors.isLoading}
        items={sortPickerItems({
          data: requestors.requestors ?? [],
          userDetails,
          includeAvatar: true,
          useIdAsKey: false,
          t,
        })}
        label={t("Requestor")}
        onSelectionChange={function (keys): void {
          filterParams.setParam("requestor", Array.from(keys));
        }}
        selectedKeys={filterParams.params.requestor?.split(",") || []}
        selectionMode="multiple"
        showActionBar
        trigger={AvatarTrigger}
        testID="requestor-filter"
      />

      <Picker
        isLoading={taskTypes.isLoading}
        items={
          taskTypes.taskTypes?.map((task) => {
            return { name: task.label, id: task.name };
          }) ?? []
        }
        label={t("Type")}
        onSelectionChange={function (keys): void {
          filterParams.setParam("type", Array.from(keys));
        }}
        selectedKeys={filterParams.params.type?.split(",") || []}
        selectionMode="multiple"
        showActionBar
        testID="type-filter"
      />
    </>
  );
}
